import { useEffect, useState } from 'react'

import { EquipmentSelectOption } from 'pages/costs/common/equipmentSelectHelpers'

type CombinationState = {
	technicalOptions: EquipmentSelectOption[]
	transmissionOptions: EquipmentSelectOption[]
	loading: boolean
}

const combinationCache = new Map<
	number,
	{ technicalOptions: EquipmentSelectOption[]; transmissionOptions: EquipmentSelectOption[] }
>()

export const useEquipmentCombinations = (serviceTypeId?: number, equipmentService?: any): CombinationState => {
	const [state, setState] = useState<CombinationState>({
		technicalOptions: [],
		transmissionOptions: [],
		loading: false,
	})

	useEffect(() => {
		let cancelled = false

		if (!serviceTypeId || !equipmentService) {
			setState({ technicalOptions: [], transmissionOptions: [], loading: false })
			return
		}

		const cached = combinationCache.get(serviceTypeId)
		if (cached) {
			setState({ ...cached, loading: false })
			return
		}

		setState((prev) => ({ ...prev, loading: true }))

		const loadOptions = async () => {
			try {
				const response = await equipmentService.getCombinationFieldsByServiceType(serviceTypeId)
				const technicalOptions =
					response?.technicalAttribute?.map((attr: any) => ({
						label: attr.name,
						value: attr.id,
					})) || []
				const transmissionOptions =
					response?.transmissionMedium?.map((medium: any) => ({
						label: medium.name,
						value: medium.id,
					})) || []

				if (!cancelled) {
					const combo = { technicalOptions, transmissionOptions }
					combinationCache.set(serviceTypeId, combo)
					setState({ ...combo, loading: false })
				}
			} catch (error) {
				if (!cancelled) {
					setState({ technicalOptions: [], transmissionOptions: [], loading: false })
				}
			}
		}

		loadOptions()

		return () => {
			cancelled = true
		}
	}, [serviceTypeId, equipmentService])

	return state
}
